import { useLang } from "../../i18n/LangContext";
import { LegalPage, H2, P, UL, Placeholder } from "../../components/LegalPage";

export default function Terms() {
  const { lang } = useLang();
  return (
    <LegalPage titlePl="Regulamin serwisu" titleEn="Terms of service" lang={lang} testId="terms-page">
      {lang === "pl" ? (
        <>
          <P>Korzystając z aplikacji AI Dating Coach akceptujesz niniejszy regulamin. Operatorem usługi jest <Placeholder>Mateusz Łukasz Zalewski</Placeholder>, <Placeholder>Wołomin ul.Szkolna 2</Placeholder>, E-mail <Placeholder>kontakt@mateuszzalewski.pl</Placeholder>.</P>

          <H2>1. Czym jest AI Dating Coach</H2>
          <P>To prywatny panel analityczny wspierany przez modele AI (OpenRouter: DeepSeek + GPT-4o-mini). Aplikacja NIE loguje się do Tindera ani innej aplikacji randkowej, NIE wysyła wiadomości i NIE wykonuje automatycznych akcji w Twoim imieniu. Użytkownik samodzielnie wkleja treści do analizy.</P>

          <H2>2. Charakter porad</H2>
          <P>Raporty generowane przez AI mają charakter <b>informacyjny i rozrywkowy</b>. Nie stanowią porady psychologicznej, medycznej ani prawnej. Operator nie ponosi odpowiedzialności za skutki decyzji podjętych na podstawie raportów.</P>

          <H2>3. Konto, logowanie i dane e-mail</H2>
          <P>Dostęp do funkcji premium wymaga założenia konta. Możesz zarejestrować się przez e-mail i hasło albo zalogować się kontem Google (poczta Google/iCloud). <b>Twój adres e-mail jest zbierany i wykorzystywany</b> w celu: (a) utworzenia i obsługi konta, (b) zapisania wykupionych kredytów i subskrypcji, (c) wysyłki newslettera oraz kursu e-mailowego z poradami, (d) kontaktu w sprawach dotyczących usługi. W każdej chwili możesz wypisać się z newslettera linkiem w wiadomości. Zobowiązujesz się do nieudostępniania danych logowania osobom trzecim.</P>

          <H2>4. Płatności i subskrypcja</H2>
          <UL>
            <li>Premium jednorazowy: 9,99 PLN za 1 kredyt (1 raport premium).</li>
            <li>Pakiet 10 kredytów: 39,00 PLN.</li>
            <li>Subskrypcja miesięczna: 49,90 PLN/miesiąc — obejmuje 15 kredytów przyznawanych po każdej skutecznie opłaconej płatności i odnawia się automatycznie. Możesz wyłączyć auto-odnowienie w dowolnym momencie z panelu Premium; zachowasz dostęp do końca opłaconego okresu.</li>
            <li>Płatności obsługuje Stripe. Akceptujemy kartę i kryptowaluty (dla pakietów jednorazowych).</li>
          </UL>

          <H2>5. Prawo odstąpienia (konsument UE)</H2>
          <P>Zgodnie z art. 38 pkt 13 ustawy o prawach konsumenta, prawo odstąpienia od umowy nie przysługuje, jeśli usługa cyfrowa została w pełni wykonana (raport AI wygenerowany) za wyraźną zgodą konsumenta i z utratą prawa odstąpienia. Składając zamówienie, świadomie wyrażasz tę zgodę.</P>
          <P>W przypadku subskrypcji, możesz w każdej chwili wyłączyć auto-odnowienie. Zwrot za niewykorzystany czas po anulowaniu nie jest standardowo udzielany.</P>

          <H2>6. Zakazane treści</H2>
          <P>Zabronione jest przesyłanie do analizy:</P>
          <UL>
            <li>materiałów dotyczących osób niepełnoletnich,</li>
            <li>danych osób bez ich zgody w kontekście naruszającym ich dobra osobiste,</li>
            <li>treści nielegalnych, dyskryminujących, podżegających do nienawiści.</li>
          </UL>

          <H2>7. Ograniczenie odpowiedzialności</H2>
          <P>Operator nie odpowiada za przerwy techniczne, błędy modeli AI ani za decyzje podjęte przez użytkownika. Całkowita odpowiedzialność operatora ograniczona jest do wysokości opłaty wniesionej w ciągu ostatnich 12 miesięcy.</P>

          <H2>8. Reklamacje</H2>
          <P>Reklamacje należy zgłaszać na adres <Placeholder>kontakt@mateuszzalewski.pl</Placeholder>. Rozpatrzymy je w terminie 14 dni.</P>

          <H2>9. Postanowienia końcowe</H2>
          <P>Prawem właściwym jest prawo polskie. Spory rozstrzyga sąd właściwy dla siedziby operatora, chyba że ustawa stanowi inaczej.</P>
        </>
      ) : (
        <>
          <P>By using AI Dating Coach you accept these terms. The service is operated by <Placeholder>Mateusz Łukasz Zalewski</Placeholder>, <Placeholder>Wołomin ul. Szkolna 2</Placeholder>.</P>

          <H2>1. About AI Dating Coach</H2>
          <P>A private analysis panel powered by AI (OpenRouter: DeepSeek + GPT-4o-mini). The app does NOT log into Tinder or any dating app, does NOT send messages, and does NOT perform any automated action on your behalf. You manually paste content for analysis.</P>

          <H2>2. Nature of the advice</H2>
          <P>AI-generated reports are for <b>information and entertainment</b>. They are not psychological, medical or legal advice. The operator is not liable for decisions made based on the reports.</P>

          <H2>3. Account, login and email data</H2>
          <P>Premium features require an account. You can register with email and password, or sign in with a Google account (Google/iCloud mail). <b>Your email address is collected and used</b> to: (a) create and manage your account, (b) store your purchased credits and subscription, (c) send our newsletter and email tips course, (d) contact you about the service. You can unsubscribe from the newsletter anytime via the link in each email. You agree not to share your login credentials with third parties.</P>

          <H2>4. Payments and subscription</H2>
          <UL>
            <li>One-off premium: 9.99 PLN for 1 credit (1 premium report).</li>
            <li>10-credit pack: 39.00 PLN.</li>
            <li>Monthly subscription: 49.90 PLN/month — includes 15 credits granted after each successfully paid billing cycle and auto-renews. You can cancel auto-renewal at any time from the Premium panel; access remains until the end of the paid period.</li>
            <li>Payments handled by Stripe. We accept cards and crypto (one-off packs).</li>
          </UL>

          <H2>5. Right of withdrawal (EU consumer)</H2>
          <P>Per Polish consumer law (Art. 38(13)), the right to withdraw does not apply once a digital service has been fully performed (AI report generated) with your express consent and acknowledged loss of withdrawal right. Placing an order constitutes that consent.</P>
          <P>For subscriptions, you can disable auto-renewal anytime. Refunds for unused subscription time are not standard.</P>

          <H2>6. Prohibited content</H2>
          <P>You may not submit:</P>
          <UL>
            <li>material involving minors,</li>
            <li>data about persons without their consent in a way that violates their rights,</li>
            <li>illegal, discriminatory or hateful content.</li>
          </UL>

          <H2>7. Limitation of liability</H2>
          <P>The operator is not liable for downtime, AI model errors, or decisions taken by the user. Total liability is capped at the fees paid in the last 12 months.</P>

          <H2>8. Complaints</H2>
          <P>Send complaints to <Placeholder>kontakt@mateuszzalewski.pl</Placeholder>. We will respond within 14 days.</P>

          <H2>9. Final provisions</H2>
          <P>Polish law governs. Disputes are resolved by the court competent for the operator&apos;s seat unless statute provides otherwise.</P>
        </>
      )}
    </LegalPage>
  );
}
